import { render, staticRenderFns } from "./caiJingDetail.vue?vue&type=template&id=cdf384ca&scoped=true&"
import script from "./caiJingDetail.vue?vue&type=script&lang=js&"
export * from "./caiJingDetail.vue?vue&type=script&lang=js&"
import style0 from "./caiJingDetail.vue?vue&type=style&index=0&id=cdf384ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf384ca",
  null
  
)

export default component.exports